export default __webpack_public_path__ + "transfix-ui/components/SideNav/Nav-BG.5c454a8dfa159bf06283ab157c78be29.png";